<script>
  export let data;
</script>

<div class="slider-last-slide-container">
  {#if data.broker.length !== 0}
    <div class="align-self-center align-self-md-start profile-photo-container">
      <img src={data?.broker[0]?.brokerDetails[0]?.profilePhoto[0]?.url} />
    </div>
  {/if}

  <div class="row justify-content-center">
    {#if data.broker.length !== 0}
      <div class="col-md-6">
        <h1 class="title is-4">
          {data?.broker[0]?.fullName?.trim()}{data?.broker[0]
            ?.brokerBranchDetails[0]?.roleTitle && ","}
          <br />
          {data?.broker[0]?.brokerBranchDetails[0]?.roleTitle}
        </h1>
        <h2 class="title is-4">
          Ph:
          <a href={`tel:${data?.broker[0]?.brokerDetails[0]?.ddiPhone}`}
            >{data?.broker[0]?.brokerDetails[0]?.ddiPhone}</a
          >
          <br /> Mob:
          <a href={`tel:${data?.broker[0]?.brokerDetails[0]?.mobile}`}
            >{data?.broker[0]?.brokerDetails[0]?.mobile}</a
          ><br /> Em:
          <a href={`mailto:${data?.broker[0]?.email}`}
            >{data?.broker[0]?.email}</a
          >
        </h2>
      </div>
    {/if}

    <div class={data.broker.length !== 0 ? "col-md-6" : "mt-5 col-md-6"}>
      <p>
        {@html data?.brokerMessage}
      </p>
    </div>
  </div>
</div>

<style>
  .slider-last-slide-container {
    display: flex;
    flex-direction: column;
    margin-top: 98px;
    padding-right: 20px;
    padding-left: 20px;
    color: white;
  }
  @media (max-width: 568px) {
    .slider-last-slide-container {
      padding-right: 0px;
      padding-left: 0px;
    }
  }
  @media (min-width: 1200px) {
    .slider-last-slide-container {
      margin-top: 110px;
      padding-right: 141px;
      padding-left: 141px;
    }
  }
  .profile-photo-container img {
    border-radius: 213px;
    height: 213px;
    width: 213px;
    object-fit: cover;
  }
  .row {
    margin: 0;
  }
  h1.title {
    margin-bottom: 26px;
  }
  h2.title {
    font-size: 20px;
  }
  @media (max-width: 568px) {
    .col-md-6 {
      padding: 10px 0px;
    }
  }

  .profile-photo-container {
    margin-bottom: 26px;
  }
  .white-space {
    white-space: break-spaces;
  }
  @media (max-width: 768px) {
    p {
      font-size: 1.2rem;
    }
  }
</style>
